import type { FacilityFlowCoreModulesPlanningDtosWorkScheduleModelsDeviatingDayDto as DeviatingDay } from '../../api/generated/models';

export interface DeviatingGroup {
  current: number;
  model: number;
  /** ISO dates in the order the API sent them (ascending). */
  dates: string[];
}

/**
 * Deviating days grouped by their target change, so 15 days of 8 h → 7 h read as one line in the
 * change preview (FAFD-67). Own file so the modal only exports components (Fast Refresh).
 */
export function groupDeviating(days: DeviatingDay[]): DeviatingGroup[] {
  const groups = new Map<string, DeviatingGroup>();
  for (const day of days) {
    const current = day.currentTargetHours ?? 0;
    const model = day.modelTargetHours ?? 0;
    const key = `${current}|${model}`;
    const group = groups.get(key) ?? { current, model, dates: [] };
    group.dates.push(day.date!);
    groups.set(key, group);
  }
  return [...groups.values()];
}
